<label
  class="{{classLabel}}"
  for="{{label}}"
>
    {{text}}
    <input
      class="{{classField}}"
      type="{{type}}"
      name="{{label}}"
      placeholder="{{placeholder}}"
      {{required}}
    >
</label>
